export const navigationBottom = [
  {
    text: 'Ana Sayfa',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Examples',
    icon: 'folder',
    items: [
      {
        text: 'Profile',
        path: '/profile'
      },
      {
        text: 'Tasks',
        path: '/tasks'
      }
    ]
  }, 
  {
    text: 'Fon Portföyüm',
    path: '/fon-portfoyum',
    icon: 'folder'
  }
  ];
